import { FC } from 'react'
import * as styles from 'components/features/socialFeed/FeedPost/FeedPostText.styl'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'

type ReadMoreProps = {
  onClick: () => void
}
export const ReadMoreHighlight: FC<ReadMoreProps> = ({ onClick }) => (
  <span key='readMore'>
    ...
    <span
      className={ styles.readMore }
      onClick={ onClick }
    >
      Read&nbsp;More
    </span>
  </span>
)

type TagProps = {
  tag: string
}
export const TagHighlight: FC<TagProps> = ({ tag }) => (
  <NavigationLink className={ styles.link } to={{ anchor: 'feedtag', id: tag.substr(1) }}>
    { tag }
  </NavigationLink>
)

type LinkProps = {
  url: string
}
export const LinkHighlight: FC<LinkProps> = ({ url }) => {
  const href = url.substr(0, 3) === 'www'
    ? `http://${ url }`
    : url

  return (
    <a className={ styles.link } target='_blank' rel='noopener noreferrer' href={ href }>{ url }</a>
  )
}

type MentionProps = {
  mention: string
}
export const MentionHighlight: FC<MentionProps> = ({ mention }) => (
  <NavigationLink className={ styles.link } to={{ anchor: 'feedauthor', id: mention.substr(1) }}>
    { mention }
  </NavigationLink>
)
